import { LocaleValue } from "@eres/core/dist/LocaleValue";
import Action, { TempDataActions } from "@my-dld/actions";
import { AnyAction } from "redux";

export interface MessageDataOptions {
	icon: string;
	noOkButton?: boolean;
	okLabel?: string;
	iconWrap?: string;
	title?: LocaleValue;
}

export interface MessageData {
	message: string,
	options: MessageDataOptions
}

export interface TempDataState {
	isLoading: boolean;
	loadCount: number;
	message?: string;
	error?: string;
	info?: MessageData;
	loaderExtraClass?: string;
	isRefreshing: boolean;
}

export const defaultState: TempDataState = {
	isLoading: false,
	loadCount: 0,
	isRefreshing: false
};

export function TempDataReducer( state = defaultState, action: AnyAction ) {
	switch ( action.type ) {
		case TempDataActions.ON_LOAD_DATA:
			return {
				...state,
				loadCount: state.loadCount + 1,
				isLoading: true,
			};
		case TempDataActions.ON_LOAD_DATA_DONE:
			let loadCount = state.loadCount - 1;
			if ( loadCount < 0 ) loadCount = 0;
			return {
				...state,
				loadCount: loadCount,
				isLoading: loadCount > 0,
			};
		case TempDataActions.SHOW_MESSAGE:
			return {
				...state,
				message: action.payload
			};
		case TempDataActions.SHOW_INFO:
			return {
				...state,
				info: action.payload
			};
		case TempDataActions.SHOW_ERROR:
			return {
				...state,
				error: action.payload
			};
		case TempDataActions.HIDE_MESSAGE:
			return {
				...state,
				message: undefined,
				info: undefined,
			};
		case TempDataActions.HIDE_ERROR:
			return {
				...state,
				error: undefined
			};
		case TempDataActions.LOADER_CSS_CLASS:
			return {
				...state,
				loaderExtraClass: action.payload
			};
		case Action.USER_REFRESHING:
			return { ...state, isRefreshing: action.payload };
		default:
			return state;
	}
}
